import { useCallback } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Context } from "types/generated";

import useContextsAnalytics from "../../useContextsAnalytics";

const ContextsTableDescriptionCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  const trackAnalytics = useContextsAnalytics();

  const handleShowFullDescription = useCallback(() => {
    trackAnalytics("Show full description clicked");
  }, [trackAnalytics]);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription
        description={context.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </TableSimpleCell>
  );
};

export default ContextsTableDescriptionCell;
